
<template>
  <el-dialog
    class="dialog-d  DiaBusinessCard"
    :modelValue="show"
    :modal-class="' dialog-m-center  '"
    width="580px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :show-close="false"
    :append-to-body="true"
    @close="onClose"
  >
    <template #header>
      <DiaHeader @close="onClose">
        <template #title>
          <span class="title bold">{{ $t('home.inviteShare') }}</span>
        </template>
      </DiaHeader>
    </template>
    <div class="w-100b position-r">
      <img v-if="!isBeginning" src="@/image/home/swiper-slidePrev.webp" class="o-hidden w-40 h-40 pointer position-a top-260 left-30 z-99" @click="slidePrev">
      <img v-if="!isEnd" src="@/image/home/swiper-slideNext.webp" class="o-hidden w-40 h-40 pointer position-a top-260 right-30 z-99" @click="slideNext">
      <Swiper
        :id="swiperDomId"
        class="w-302 z-99 "
        :slidesPerView="1"
        :spaceBetween="30"
        :loop="false"
        :navigation="false"
        :modules="[Navigation]"
      >
        <swiper-slide v-for="(key) in Object.keys(imgBase64s)" :key="key" class="w-300 h-534 border o-hidden image-box">
          <!-- <img class=" w-300 h-534 " :src="imgBase64s[key]"> -->
          <el-image class="w-300 h-534" :src="imgBase64s[key]">
            <template #error>
              <Row class="w-300 h-534" x="c" y="c">
                {{ $t('home.loading') }}
              </Row>
            </template>
          </el-image>
        </swiper-slide>
      </Swiper>
    </div>
    <Row class="w-100b m-t-25" x="e">
      <el-button class="w-min-68 h-44 radius-4 m-r-10" link :loading="loading" @click="onClose">{{ $t('form.cancel') }}</el-button>
      <el-button class="w-min-68 h-44 radius-4" type="primary" :loading="loading" @click="submit">{{ $t('form.download') }}</el-button>
    </Row>
  </el-dialog>
</template>
<script setup>
import { Swiper, SwiperSlide, useSwiper } from 'swiper/vue'
import { Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import QRcode from 'jr-qrcode'
import zh_cnbgImage1 from '@/image/home/1zh_cn.jpg'
import zh_cnbgImage2 from '@/image/home/2zh_cn.jpg'
import zh_cnbgImage3 from '@/image/home/3zh_cn.jpg'
import zh_cnbgImage4 from '@/image/home/4zh_cn.jpg'
import zh_cnbgImage5 from '@/image/home/5zh_cn.jpg'
import zh_cnbgImage6 from '@/image/home/6zh_cn.jpg'

import zh_twbgImage1 from '@/image/home/1zh_tw.png'
import zh_twbgImage2 from '@/image/home/2zh_tw.png'
import zh_twbgImage3 from '@/image/home/3zh_tw.png'
import zh_twbgImage4 from '@/image/home/4zh_tw.png'
import zh_twbgImage5 from '@/image/home/5zh_tw.png'
import zh_twbgImage6 from '@/image/home/6zh_tw.png'

import zh_enbgImage1 from '@/image/home/1us_en.png'
import zh_enbgImage2 from '@/image/home/2us_en.png'
import zh_enbgImage3 from '@/image/home/3us_en.png'
import zh_enbgImage4 from '@/image/home/4us_en.png'
import zh_enbgImage5 from '@/image/home/5us_en.png'
import zh_enbgImage6 from '@/image/home/6us_en.png'

const emit = defineEmits()
const configStore = useConfigStore()
const props = defineProps({
  modelValue: {
    default: false
  },
  close: {},
  link: {},
  submited: {},
})

let show = $ref(props?.modelValue ?? false)
let loading = $ref(false)
let isBeginning = $ref(true)
let isEnd = $ref(false)
let activeIndex = $ref(0)
let isLocked = $ref(false)
const swiperDomId = `swiper-${randomString()}`

const imgBase64s = reactive({
  1: '',
  2: '',
  3: '',
  4: '',
  5: '',
  6: '',
})
let myCodeImage = $ref()

const slidePrev = () => {
  const swiper = document.querySelector('#' + swiperDomId).swiper
  swiper.slidePrev()
  activeIndex = swiper.activeIndex
  isBeginning = swiper.isBeginning
  isEnd = swiper.isEnd
  isLocked = swiper.isLocked
}

const slideNext = () => {
  const swiper = document.querySelector('#' + swiperDomId).swiper
  swiper.slideNext()
  activeIndex = swiper.activeIndex
  isBeginning = swiper.isBeginning
  isEnd = swiper.isEnd
  isLocked = swiper.isLocked
}

const initSwiper = () => {
  nextTick(() => {
    const swiper = document.querySelector('#' + swiperDomId).swiper
    activeIndex = swiper.activeIndex
    isBeginning = swiper.isBeginning
    isEnd = swiper.isEnd
    isLocked = swiper.isLocked
  })
}
const handleImg = async (imgSrc, k) => {
  const image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = () => {
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)

    // var myImage2 = new Image()
    // myImage2.src = QRcode.getQrBase64(myImage2Code)// 二维码图片

    context.drawImage(myCodeImage, 600 - 0, 1200 - 10, 110, 110)
    canvas.toBlob(() => {
      imgBase64s[k] = canvas.toDataURL('image/jpg')
    })
  }
  image.src = imgSrc
}

const onClose = () => {
  show = false
  if (props?.close) {
    props?.close()
  }
  emit('close', false)
  emit('update:modelValue', false)
}

const submit = async () => {
  try {
    loading = true
    downloadImage(imgBase64s[activeIndex + 1])
  } finally {
    loading = false
  }
}

const iamgeMap = $computed(() => {
  if (configStore.locale === LANGCN) {
    return {
      1: zh_cnbgImage1,
      2: zh_cnbgImage2,
      3: zh_cnbgImage3,
      4: zh_cnbgImage4,
      5: zh_cnbgImage5,
      6: zh_cnbgImage6,
    }
  }
  if (configStore.locale === LANGTW) {
    return {
      1: zh_twbgImage1,
      2: zh_twbgImage2,
      3: zh_twbgImage3,
      4: zh_twbgImage4,
      5: zh_twbgImage5,
      6: zh_twbgImage6,
    }
  }
  // 默认使用英文作为兜底
  return {
    1: zh_enbgImage1,
    2: zh_enbgImage2,
    3: zh_enbgImage3,
    4: zh_enbgImage4,
    5: zh_enbgImage5,
    6: zh_enbgImage6,
  }
})

onMounted(() => {
  nextTick(() => {
    myCodeImage = new Image()
    myCodeImage.src = QRcode.getQrBase64(props.link)// 二维码图片
    myCodeImage.onload = () => {
      Object.keys(imgBase64s).forEach(k => {
        handleImg($f.getAssetsFile(iamgeMap[k]), k)
      })
    }
  })
})

watch(() => props.modelValue, (v) => {
  show = v
  if (show == true) {
    nextTick(() => {
      initSwiper()
    })
  }
})

</script>

<style lang="scss">
@use "sass:math";
@use "sass:map";
@use '@/sass/var/index.scss' as *;

.DiaBusinessCard{
  .el-input__wrapper{
    --el-input-bg-color: #{$color-line};
  }
}
</style>
